import React from 'react';

interface PolygonDownProps {
  className?: string;
  style?: React.CSSProperties;
}

const PolygonDown: React.FC<PolygonDownProps> = ({ className, style }) => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M5.04526 6.6432C4.6536 7.26987 3.74093 7.26987 3.34927 6.6432L0.153514 1.53C-0.262765 0.863949 0.216079 -7.8516e-07 1.00151 -7.16495e-07L7.39302 -1.57732e-07C8.17845 -8.90674e-08 8.6573 0.863951 8.24102 1.53L5.04526 6.6432Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PolygonDown;
